var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5181 3.96924V4.96924",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3428 14.9033L5.61783 14.2145L6.3428 14.9033ZM8.51807 9.96924C8.51807 7.7601 10.3089 5.96924 12.5181 5.96924V3.96924C9.20436 3.96924 6.51807 6.65553 6.51807 9.96924H8.51807ZM8.51807 12.7256V9.96924H6.51807V12.7256H8.51807ZM6.51807 16.9692C6.51807 16.435 6.72618 15.9516 7.06778 15.592L5.61783 14.2145C4.93721 14.9309 4.51807 15.9022 4.51807 16.9692H6.51807ZM7.51807 16.9692H6.51807V18.9692H7.51807V16.9692ZM17.5181 16.9692H7.51807V18.9692H17.5181V16.9692ZM18.5181 16.9692H17.5181V18.9692H18.5181V16.9692ZM17.9684 15.592C18.31 15.9516 18.5181 16.435 18.5181 16.9692H20.5181C20.5181 15.9022 20.0989 14.9309 19.4183 14.2145L17.9684 15.592ZM16.5181 9.96924V12.7256H18.5181V9.96924H16.5181ZM12.5181 5.96924C14.7272 5.96924 16.5181 7.7601 16.5181 9.96924H18.5181C18.5181 6.65553 15.8318 3.96924 12.5181 3.96924V5.96924ZM19.4183 14.2145C18.8104 13.5746 18.5181 13.1272 18.5181 12.7256H16.5181C16.5181 14.0193 17.4086 15.0029 17.9684 15.592L19.4183 14.2145ZM4.51807 16.9692C4.51807 18.0738 5.4135 18.9692 6.51807 18.9692V16.9692H4.51807ZM18.5181 18.9692C19.6226 18.9692 20.5181 18.0738 20.5181 16.9692H18.5181V18.9692ZM6.51807 12.7256C6.51807 13.1272 6.22573 13.5746 5.61783 14.2145L7.06778 15.592C7.62753 15.0029 8.51807 14.0193 8.51807 12.7256H6.51807Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3157 20.846C14.1493 21.1871 13.8893 21.4738 13.566 21.6727C13.2428 21.8716 12.8696 21.9743 12.4901 21.969C12.1107 21.9637 11.7405 21.8506 11.4229 21.6428C11.1054 21.435 10.8535 21.1411 10.6967 20.7954",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.c6d3bb73b82fcbb5254ffdc176945160.svg";
export { ForwardRef as ReactComponent };